import { render, staticRenderFns } from "./DistributeAccountL.vue?vue&type=template&id=80110c36&scoped=true&"
import script from "./DistributeAccountL.vue?vue&type=script&lang=js&"
export * from "./DistributeAccountL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80110c36",
  null
  
)

export default component.exports